import moment from 'moment';

const getMonths = (from, to, format = 'MM') => {
  const startDate = moment(from);
  const endDate = moment(to);

  const monthsArr = [startDate.locale('en').format(format)];
  let currentDate = startDate;

  while (currentDate.isBefore(endDate, 'month')) {
    const date = currentDate.add(1, 'month');
    monthsArr.push(date.format(format));
    currentDate = date;
  }

  return monthsArr;
};

const getFlexibleRange = (
  { moveIn, moveOut },
  { flexibleMoveIn = false, flexibleMoveOut = false } = {}
) => {
  return {
    moveIn: flexibleMoveIn
      ? moment(moveIn)
          .subtract(15, 'days')
          .format('YYYY-MM-DD')
      : moveIn,
    moveOut: flexibleMoveOut
      ? moment(moveOut)
          .add(15, 'days')
          .format('YYYY-MM-DD')
      : moveOut
  };
};

const getMonthsStaying = (
  { moveIn, moveOut },
  { flexibleMoveIn = false, flexibleMoveOut = false } = {}
) => {
  if (!moveIn || !moveOut) {
    return undefined;
  }
  const flexibleRange = getFlexibleRange(
    { moveIn, moveOut },
    { flexibleMoveIn, flexibleMoveOut }
  );
  return getMonths(flexibleRange.moveIn, flexibleRange.moveOut, 'MMM').map(
    month => month.toLowerCase()
  );
};

const getUserAge = birthDate => {
  return moment().diff(birthDate, 'years');
};

const getDaysdiff = (start, end) => {
  const startDate = moment(start);
  const endDate = moment(end);

  return endDate.diff(startDate, 'days');
};

const checkIfAvailable = (moveIn, moveOut, unavailabilities) => {
  const startDate = moment(moveIn);
  const endDate = moment(moveOut);

  return !unavailabilities.some(u => {
    const fromU = moment(u.from);
    const toU = moment(u.to);

    return startDate.isBetween(fromU, toU) || endDate.isBetween(fromU, toU);
  });
};

export default {
  getMonths,
  getFlexibleRange,
  getMonthsStaying,
  getUserAge,
  getDaysdiff,
  checkIfAvailable
};
